<template>
    <div class="sidebar-inner">
        <!-- Top Section -->
        <div class="top-section">
            <h4 class="mb-1">Bookmarks</h4>
            <hr>

            <!-- No Bookmarks-->
            <div v-if="bookmarks.length == 0">
                <div class="mt-3">
                    <div class="property-card">
                        <b class="property-name text-danger">
                            No bookmarks to show
                        </b>
                    </div>
                </div>
            </div>
            <!-- / No Bookmarks-->

            <!-- Has Bookmarks -->
            <div class="bookmarks">
                <bookmark 
                :key="`bookmark-${i}`"
                v-for="(bookmark, i) in bookmarks"
                :bookmark="bookmark"></bookmark>
            </div>
            <!-- / Has Bookmarks -->
        </div>
        <!-- / Top Section -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Bookmark from './BookmarksSidebar/Bookmark.vue';

export default {
    computed: {
        ...mapGetters('ticketViewer', {
            bookmarks: 'bookmarks'
        })
    },

    components: {
        Bookmark
    }
}
</script>

<style scoped lang="scss">
.property-card {
    background: #fff;
    border-radius: 5px;
    padding: 15px;

    .property-name {
        font-weight: 600;
        color: #2c5cc5;
    }
}
</style>